import {
    Component, EventEmitter, Input, Output,
    ViewEncapsulation
} from '@angular/core';
import { CardModel } from '../../../shared/models/card.model';
import { CommonHttpService } from '../../../shared/services/http.service';
import { Response } from '@angular/http';
import { ClientModel } from '../../../shared/models/client.model';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'account-cards-item',
    templateUrl: './account.cards.item.component.html',
    encapsulation: ViewEncapsulation.None
})
export class AccountCardsItemComponent {
    @Input('card') card: CardModel;
    @Input('client') client: ClientModel;
    @Output() deleting: EventEmitter<any> = new EventEmitter<any>();
    @Output() deleted: EventEmitter<any> = new EventEmitter<any>();
    @Output() failed: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        protected http: CommonHttpService,
        protected toastr: ToastrService,
        protected translate: TranslateService
    ) {}

    public delete() {
        this.deleting.emit();
        this.http
            .useAuth()
            .delete(`account/clients/${this.client.id}/cards/${this.card.id}`)
            .subscribe((response: Response) => {
                this.translate
                    .get('ACCOUNT.CARDS.DELETE_SUCCESS_MESSAGE')
                    .subscribe((message) => {
                        this.toastr.success(message);
                        this.deleted.emit();
                    });
            }, () => {
                this.translate
                    .get('ACCOUNT.CARDS.DELETE_ERROR_MESSAGE')
                    .subscribe((message) => {
                        this.toastr.error(message);
                        this.failed.emit();
                    });
            });
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/app/account/cards/item/account.cards.item.component.ts